import { axios } from 'lib/axios';

export const loginWithFacebook = ({ code }) => {
  return axios.get(`/v2/oauth/facebook/callback?code=${code}`);
};
